import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '../auth/keycloakProvider';

const Index = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isSystemAdmin, loading } = useKeycloak();

  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) {
      navigate(isSystemAdmin ? '/dashboard' : '/ecmrs');
    } else {
      navigate('/login');
    }
  }, [isAuthenticated, isSystemAdmin, navigate, loading]);

  return null;
};

export default Index;
